import mod from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AcNotice.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./AcNotice.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./admin/src/js/components/AcNotice.vue?vue&type=script&lang=js
// module id = 9
// module chunks = 0